import styled from 'styled-components'

import { pageLayoutMaxWidthPixels } from '@syconium/little-miss-figgy'

export const CategoryContainer = styled.section`
  max-width: ${pageLayoutMaxWidthPixels}px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
`
export const CategoryList = styled.div`
  > * {
    width: 100%;
  }
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60px;
  padding: 20px 0;
`
